module.exports = __webpack_public_path__ + "assets/example.894f4689.svg";